<template>
  <p class="clearfix mb-0" />
</template>

<script>
import Footer from '@/views/logics/components/Footer'

export default {
  mixins: [Footer],
}
</script>
